import React from "react";
import NavBar from "../../components/YourStylist/NavBar";
import Hero from "../../components/YourStylist/Hero";
import Products from "../../components/YourStylist/Prodcuts";
import Arrival from "../../components/YourStylist/Arrival";
import Footer from "../../components/YourStylist/Footer";
import "./styles.css";
const HomePage = () => {
  return (
    <div className="yourstylist">
      <NavBar />
      <Hero />
      <Products title={"Trending"} subTitle={"Hot Items"} />
      <Arrival />
      <Footer />
    </div>
  );
};

export default HomePage;
